import type { GetCourseDrafts200ContentItem } from './getCourseDrafts200ContentItem';
import type { GetCourseDrafts200Pageable } from './getCourseDrafts200Pageable';

export type GetCourseDrafts200 = {
  content?: GetCourseDrafts200ContentItem[];
  /** Spring Data Page 객체 형태의 페이징 정보 */
  pageable?: GetCourseDrafts200Pageable;
};
